document.addEventListener(
  "click",
  (e) => {
    const bssCheckout = document.querySelector(".proceed-to-checkout");
    if (!bssCheckout || typeof window.BSS_B2B === "undefined") {
      return;
    }
    if (window.BSS_B2B && bssCheckout && e.target.name === "checkout") {
      e.preventDefault();
      e.stopImmediatePropagation();
      bssCheckout.click();
    }
  },
  true
);